module.exports = __webpack_public_path__ + "img/seeprize_btn.2c31931c.png";